import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import { contentRender } from "@/libs/contentRender";
import VueScroll from "vuescroll";
import SplitPanel from "@/components/SplitPanel";
import { CodeEditor } from "../CodeEditor";
import { LikeOrNot } from "../LikeOrNot/index";
import { State } from "vuex-class";
import { getCodeHint } from "@/api/coding";
import get = Reflect.get;

@Component({
    components: {
        VueScroll,
        SplitPanel,
        CodeEditor,
        LikeOrNot
    }
})
export default class CodeHintItem extends Vue {
    @Prop() readonly item!: any;
    @Prop() readonly section!: any;
    @Prop() readonly teacherAvatar: string;

    @State("study") studyState: object;
    private ops: any = {
        vuescroll: {
            mode: "native"
        },
        scrollPanel: {},
        rail: {},
        bar: {
            onlyShowBarOnScroll: false,
            background: "rgba(0, 0, 0, .4)"
        }
    };
    private offset: number = 0.218;
    private hideDesc: string = "";
    private myHints: Array<string> = [];

    mounted() {
        this.$nextTick(() => {
            this.hideDesc = contentRender(this.item.page.desc);
            this.item.page.hints.forEach(item => {
                this.myHints.push(item.content);
            });
        });
    }
    viewHint() {
        getCodeHint(this.item.id, this.myHints.length).then(res => {
            //@ts-ignore
            if (res.code === 200) {
                this.myHints.push(res.data);
            } else {
                //@ts-ignore
                this.$message.warning(res.msg);
            }
        });
    }
    @Emit()
    next() {}
    @Emit()
    handleJumpClick() {}
}

//@ts-ignore
export { default as CodeHintItem } from "./index.vue";
